import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { FastracColsService } from '@bds/services';
import { CommunicationService } from '@bds/core';
import { CarIdTransformService } from '@bds/helpers';
import { bdsGridModeType } from '@bds/components';
import { RtMultiTripClmDialogComponent, TripClmDialogData } from '@bds/railtrac';
import { RtClmView } from '@bds/railtrac-models';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'lib-rt-shipment-car-situation-current-report',
    templateUrl: './rt-shipment-car-situation-current-report.component.html',
    styleUrls: ['./rt-shipment-car-situation-current-report.component.css'],
})
export class RtShipmentCarSituationCurrentReportComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    public gridId = 101;
    public gridMode: bdsGridModeType = 'multiple';
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Shipment Car Situation Current Report';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];

    public iconAddClm = faPlus;

    @ViewChild(FastracDxGridWrapperComponent) wrapper: FastracDxGridWrapperComponent;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public gridColumnService: FastracColsService,
        public communicationService: CommunicationService,
        public carIdTransformService: CarIdTransformService,
        public reportService: RailtracReportsService,
        public pageService: PageService,
        public dialog: MatDialog,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);
    }

    get hasSelectedCars(): boolean {
        return (this.wrapper?.grid?.instance?.getSelectedRowsData()?.length ?? 0) > 0;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngOnInit() {
        super.ngOnInit();
        this.pageService.setHeader(this.pageHeader);

        this.gridSource = new DataSource(
            this.reportService.CreateAspNetDatastore(this.apiCall, this.gridId.toString()),
        );
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const instance = this.wrapper?.grid?.instance;
            if (!instance) {
                return;
            }

            instance.option('onRowDblClick', (e: any) => {
                const ormId = e?.data?.orm_id;
                if (ormId == null) {
                    return;
                }
                window.open(`/trips/detail/${ormId}#tripdetailsanchor`, '_blank');
            });

            instance.option('selection.showCheckBoxesMode', 'onClick');
            instance.option('selection.allowSelectAll', true);
        }, 0);
    }

    addClmsDialog(): void {
        const instance = this.wrapper?.grid?.instance;
        const clms = this.distinctSelectedCars(instance?.getSelectedRowsData() ?? []);

        if (clms.length === 0) {
            return;
        }

        const dialogRef: MatDialogRef<RtMultiTripClmDialogComponent, TripClmDialogData> =
            this.dialog.open(RtMultiTripClmDialogComponent, {
                data: {
                    clms,
                } as TripClmDialogData,
                minWidth: 1000,
            });

        dialogRef.afterClosed().subscribe(() => {
            instance?.clearSelection();
            this.wrapper?.refreshGrid();
        });
    }

    private distinctSelectedCars(rows: Array<any>): RtClmView[] {
        const seen = new Set<string>();
        const cars: RtClmView[] = [];

        for (const row of rows) {
            const carInit = row?.car_init;
            const carNo = row?.car_no;

            if (!carInit || !carNo) {
                continue;
            }

            const carId = `${carInit}|${carNo}`;
            if (seen.has(carId)) {
                continue;
            }

            seen.add(carId);
            cars.push({ carInit, carNo } as RtClmView);
        }

        return cars;
    }
}
